export const HOME_TRANSLATE = {
    home: {
        breadcrumbName: "Home",
        actions: {
            goToLogin: {
                text: "Customer Area"
            },
            goToJoinin: {
                text: "Learn More"
            },
            followUpComplaints: {
                text: "Track Complaint"
            }
        }
    }
}
